import { Accordion, AccordionDetails, AccordionSummary, Box, Button, FormControl, FormControlLabel, FormLabel, Grid, InputBase, MenuItem, Radio, RadioGroup, Select, TextField, Typography } from "@mui/material"
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import PassengerImg from "../img/usericonacc.png"
import TravelImg from "../img/travel-icon.png"
import AddIcon from '@mui/icons-material/Add';
import styled from "@emotion/styled";
import { useState } from "react";
import formik, { useFormik } from "formik";
import * as Yup from "yup";
import { useSelector } from "react-redux";

const CustomInput = styled(InputBase)({
    fontFamily: '"Segoe UI", sans-serif',
    fontSize: "15px",
    color: ' #030213',
    "& input": {
        padding: 0,
    },
});


const AddPassanger = ({ bookedSeat, formik }) => {
    const { setFieldValue, values, handleBlur, touched, errors } = formik;

    return (<>
        <Box sx={{
            borderRadius: "12px",
            backgroundColor: "#fff",
        }}>
            <Grid container spacing={2}>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Typography sx={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: '20px',
                        fontWeight: 600,
                        textAlign: 'left',
                        color: '#1d1d1d',
                    }}>
                        Contact details
                    </Typography>
                    <Typography sx={{
                        fontFamily: 'Segoe UI',
                        fontSize: '15px',
                        fontWeight: 600,
                        textAlign: 'left',
                        color: '#364252',
                    }}>
                        Your E-ticket and updates will be sent to the following details
                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                <Grid size={{ md: 6, xs: 12 }}>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            border: "1px solid #d1d5db",
                            borderRadius: "8px",
                            padding: "8px 12px",
                            backgroundColor: "#fff",
                            width: "100%",
                            gap: "8px",
                        }}
                    >
                        <FormControl variant="standard" sx={{ minWidth: 80 }}>
                            <Select
                                fullWidth
                                defaultValue="+91"
                                disableUnderline
                                input={<CustomInput />}
                                sx={{
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: "15px",
                                    fontWeight: 500,
                                    color: '#030213',
                                }}
                            >
                                <MenuItem value="+91">🇮🇳 +91</MenuItem>
                                <MenuItem value="+1">🇺🇸 +1</MenuItem>
                                <MenuItem value="+44">🇬🇧 +44</MenuItem>
                                <MenuItem value="+61">🇦🇺 +61</MenuItem>
                            </Select>
                        </FormControl>

                        <TextField
                            name="userMobile"
                            value={values?.userMobile}
                            onChange={(event, newValue) => setFieldValue('userMobile', event.target.value)}
                            onBlur={handleBlur}
                            error={touched.userMobile && Boolean(errors.userMobile)}
                            variant="standard"
                            placeholder="Enter mobile number"
                            InputProps={{ disableUnderline: true }}
                            sx={{
                                flex: 1,
                                "& input": {
                                    fontFamily: '"Segoe UI", sans-serif',
                                    fontSize: '15px',
                                    fontWeight: 500,
                                    textAlign: 'left',
                                    color: '#030213',
                                },
                            }}
                        />
                    </Box>
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    <TextField
                        fullWidth
                        name="userEmail"
                        value={values?.userEmail}
                        onChange={(event, newValue) => setFieldValue('userEmail', event.target.value)}
                        onBlur={handleBlur}
                        error={touched.userEmail && Boolean(errors.userEmail)}
                        variant="outlined"
                        placeholder="Email ID"
                        // value={passangerFormik.values.userEmail}
                        sx={{
                            width: '100%',
                            '& .MuiOutlinedInput-root': {
                                borderRadius: '8px',
                                '& fieldset': {
                                    border: '1px solid #d1d5db',
                                },
                                '&:hover fieldset': {
                                    borderColor: '#a0a0a0',
                                },
                                '&.Mui-focused fieldset': {
                                    border: '1px solid #d1d5db',
                                },
                            },
                            '& .MuiInputBase-input': {
                                padding: '14px 10px',
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: '15px',
                                fontWeight: 500,
                                color: '#030213',
                            },
                        }}
                    />
                </Grid>
                <Grid size={{ md: 6, xs: 12 }}>
                    {/* <FormControl fullWidth>
                        <Select
                            defaultValue=""
                            displayEmpty
                            sx={{
                                borderRadius: "8px",
                                fontFamily: '"Segoe UI", sans-serif',
                                fontSize: "15px",
                                color: "#030213",
                                fontWeight: 500,
                                "& .MuiSelect-select": {
                                    padding: "14px 10px",
                                },
                                "& .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#d1d5db",
                                },
                                "&:hover .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#a0a0a0",
                                },
                                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                                    borderColor: "#d1d5db",
                                },
                            }}
                        >
                            <MenuItem value="" disabled>
                                State
                            </MenuItem>
                            <MenuItem value="1">Option 1</MenuItem>
                            <MenuItem value="2">Option 2</MenuItem>
                        </Select>
                    </FormControl> */}
                    <Typography sx={{
                        fontFamily: '"Segoe UI", sans-serif',
                        fontSize: '12px',
                        fontWeight: 500,
                        textAlign: 'left',
                        color: '#364252',
                        marginTop: '10px',
                    }}>
                        We’ll send booking confirmation to this mobile number and email
                    </Typography>
                </Grid>
            </Grid>
            <Grid container spacing={2} sx={{ marginTop: '20px' }}>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Box sx={{ borderBottom: '1px solid #ddd', width: '100%', }}></Box>
                </Grid>
                <Grid size={{ md: 9, xs: 12 }} alignItems={"center"}>
                    <Typography sx={{
                        fontFamily: 'Segoe UI',
                        fontSize: '20px',
                        fontWeight: 600,
                        textAlign: 'left',
                        color: '#1d1d1d',
                    }}>Passenger details</Typography>
                </Grid>
                {/* <Grid size={{ md: 3, xs: 12 }} sx={{ textAlign: 'end' }}>
                        <Button  variant="contained" startIcon={<AddIcon />} sx={{
                            padding: '7px 10px',
                            borderRadius: '7px',
                            backgroundColor: '#ff5714',
                            fontFamily: '"Segoe UI", sans-serif',
                            fontSize: '14px',
                            fontWeight: 500,
                            textAlign: 'center',
                            color: '#fff',
                            textTransform: 'capitalize',
                            width: '100%',
                            '&:hover': {
                                backgroundColor: '#e04e12',
                            },
                        }}>Add Passenger</Button>
                    </Grid> */}

                <Grid size={{ md: 12, xs: 12 }}>
                    <>
                        {bookedSeat && bookedSeat.map((e, i) => (

                            <Accordion key={i} sx={{
                                borderRadius: "8px",
                                boxShadow: "none",
                                border: "1px solid #e5e5e5",
                                marginBottom: "15px",
                                "&::before": {
                                    content: '""',
                                    backgroundColor: "unset",
                                    height: "unset",
                                    position: "unset",
                                },
                            }}>
                                <AccordionSummary
                                    expandIcon={<ExpandMoreIcon />}
                                    aria-controls="panel1-content"
                                    id="panel1-header"
                                >
                                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>

                                        <Typography
                                            sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '15px',
                                                fontWeight: 600,
                                                color: '#0e182b',
                                                display: 'flex',
                                                alignItems: 'center',
                                            }}
                                        >
                                            <img
                                                src={PassengerImg} alt=""
                                                style={{ verticalAlign: 'middle', marginRight: '8px' }}
                                            />
                                            Passenger 1
                                        </Typography>

                                        <Typography key={i}
                                            sx={{
                                                fontFamily: '"Segoe UI", sans-serif',
                                                fontSize: '15px',
                                                fontWeight: 'normal',
                                                color: '#364252',
                                                mt: 1,
                                            }}
                                        >
                                            Seat {e?.seat_number} {`(${e?.seat_type.charAt(0).toUpperCase() + e?.seat_type.slice(1)})`}
                                        </Typography>
                                    </Box>
                                </AccordionSummary>
                                <AccordionDetails>
                                    <Grid container spacing={2}>
                                        <Grid size={{ md: 6, xs: 12 }}>
                                            <TextField
                                                name={`addPassanger[${i}].name`}
                                                value={values?.addPassanger?.[i]?.name || ''}
                                                onChange={(event, newValue) => setFieldValue(`addPassanger[${i}].name`, event.target.value)}
                                                onBlur={handleBlur}
                                                error={
                                                    touched?.addPassanger?.[i]?.name &&
                                                    Boolean(errors?.addPassanger?.[i]?.name)
                                                }
                                                fullWidth
                                                variant="outlined"
                                                placeholder="Enter the Name"
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '8px',
                                                        '& fieldset': {
                                                            border: '1px solid #d1d5db',
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: '#a0a0a0',
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            border: '1px solid #d1d5db',
                                                        },
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '14px 10px',
                                                        fontFamily: '"Segoe UI", sans-serif',
                                                        fontSize: '15px',
                                                        fontWeight: 600,
                                                        color: '#030213',
                                                    },
                                                }}
                                            />
                                        </Grid>

                                        <Grid size={{ md: 6, xs: 12 }}>
                                            <TextField
                                                fullWidth
                                                variant="outlined"
                                                placeholder="Age"
                                                name={`addPassanger[${i}].age`}
                                                value={values?.addPassanger?.[i]?.age || ''}
                                                onChange={(event, newValue) => setFieldValue(`addPassanger[${i}].age`, event.target.value)}
                                                onBlur={handleBlur}
                                                error={
                                                    touched?.addPassanger?.[i]?.age &&
                                                    Boolean(errors?.addPassanger?.[i]?.age)
                                                }
                                                sx={{
                                                    width: '100%',
                                                    '& .MuiOutlinedInput-root': {
                                                        borderRadius: '8px',
                                                        '& fieldset': {
                                                            border: '1px solid #d1d5db',
                                                        },
                                                        '&:hover fieldset': {
                                                            borderColor: '#a0a0a0',
                                                        },
                                                        '&.Mui-focused fieldset': {
                                                            border: '1px solid #d1d5db',
                                                        },
                                                    },
                                                    '& .MuiInputBase-input': {
                                                        padding: '14px 10px',
                                                        fontFamily: '"Segoe UI", sans-serif',
                                                        fontSize: '15px',
                                                        fontWeight: 600,
                                                        color: '#030213',
                                                    },
                                                }}
                                            />
                                        </Grid>
                                    </Grid>
                                    <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                                        <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                                            <Grid size={{ md: 12, xs: 12 }}>
                                                <FormControl
                                                    fullWidth
                                                    error={
                                                        touched?.addPassanger?.[i]?.gender &&
                                                        Boolean(errors?.addPassanger?.[i]?.gender)
                                                    }
                                                >
                                                    <FormLabel
                                                        sx={{
                                                            fontFamily: '"Segoe UI", sans-serif',
                                                            fontSize: '15px',
                                                            textAlign: 'left',
                                                            color: '#364252',
                                                            marginBottom: '5px',
                                                        }}
                                                    >
                                                        Gender
                                                    </FormLabel>
                                                    <RadioGroup
                                                        row
                                                        name={`addPassanger[${i}].gender`}
                                                        value={values?.addPassanger?.[i]?.gender || ''}
                                                        onChange={(event, newValue) => setFieldValue(`addPassanger[${i}].gender`, newValue)}
                                                        onBlur={handleBlur}
                                                    >
                                                        <FormControlLabel
                                                            value="male"
                                                            control={<Radio />}
                                                            label="Male"
                                                            sx={{ fontFamily: '"Segoe UI", sans-serif', fontSize: '15px', color: '#364252' }}
                                                        />
                                                        <FormControlLabel
                                                            value="female"
                                                            control={<Radio />}
                                                            label="Female"
                                                            sx={{ fontFamily: '"Segoe UI", sans-serif', fontSize: '15px', color: '#364252' }}
                                                        />
                                                    </RadioGroup>
                                                    {touched?.addPassanger?.[i]?.gender &&
                                                        errors?.addPassanger?.[i]?.gender && (
                                                            <Typography
                                                                sx={{ fontSize: '12px', color: '#d32f2f', marginTop: '3px' }}
                                                            >
                                                                {errors.addPassanger[i].gender}
                                                            </Typography>
                                                        )}
                                                </FormControl>
                                            </Grid>
                                        </Grid>

                                    </Grid>
                                </AccordionDetails>
                            </Accordion>
                        ))}

                        {/* <Accordion sx={{
                            borderRadius: "8px",
                            boxShadow: "none",
                            border: "1px solid #e5e5e5",
                            marginBottom: "15px",
                            "&::before": {
                                content: '""',
                                backgroundColor: "unset",
                                height: "unset",
                                position: "unset",
                                top: 0,
                                left: 0,
                                right: 0,
                            },
                        }}>
                            <AccordionSummary
                                expandIcon={<ExpandMoreIcon />}
                                aria-controls="panel2-content"
                                id="panel2-header"
                            >
                                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                    <Typography
                                        sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '15px',
                                            fontWeight: 500,
                                            color: '#0e182b',
                                            display: 'flex',
                                            alignItems: 'center',
                                        }}
                                    >
                                        <img
                                            src={PassengerImg}
                                            style={{ verticalAlign: 'middle', marginRight: '8px' }}
                                        />
                                        Passenger 2
                                    </Typography>

                                    <Typography
                                        sx={{
                                            fontFamily: '"Segoe UI", sans-serif',
                                            fontSize: '15px',
                                            fontWeight: 'normal',
                                            color: '#364252',
                                            mt: 1,
                                        }}
                                    >
                                        Seat 13 (Upper)
                                    </Typography>
                                </Box>
                            </AccordionSummary>
                            <AccordionDetails>
                                <Grid container spacing={2}>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Enter the Name"
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '8px',
                                                    '& fieldset': {
                                                        border: '1px solid #d1d5db',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: '#a0a0a0',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        border: '1px solid #d1d5db',
                                                    },
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '14px 10px',
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '15px',
                                                    fontWeight: 500,
                                                    color: '#030213',
                                                },
                                            }}
                                        />
                                    </Grid>
                                    <Grid size={{ md: 6, xs: 12 }}>
                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            placeholder="Age"
                                            sx={{
                                                width: '100%',
                                                '& .MuiOutlinedInput-root': {
                                                    borderRadius: '8px',
                                                    '& fieldset': {
                                                        border: '1px solid #d1d5db',
                                                    },
                                                    '&:hover fieldset': {
                                                        borderColor: '#a0a0a0',
                                                    },
                                                    '&.Mui-focused fieldset': {
                                                        border: '1px solid #d1d5db',
                                                    },
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '14px 10px',
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '15px',
                                                    fontWeight: 500,
                                                    color: '#030213',
                                                },
                                            }}
                                        />
                                    </Grid>
                                </Grid>
                                <Grid container spacing={2} sx={{ marginTop: '10px' }}>
                                    <Grid size={{ md: 12, xs: 12 }}>
                                        <FormControl>
                                            <FormLabel
                                                sx={{
                                                    fontFamily: '"Segoe UI", sans-serif',
                                                    fontSize: '15px',
                                                    textAlign: 'left',
                                                    color: '#364252',
                                                }}
                                            >
                                                Gender
                                            </FormLabel>
                                            <RadioGroup row value={gender} onChange={genderChange}>
                                                <FormControlLabel
                                                    value="male"
                                                    control={<Radio />}
                                                    label="Male"
                                                    sx={{ fontFamily: '"Segoe UI", sans-serif', fontSize: '15px', color: '#364252' }}
                                                />
                                                <FormControlLabel
                                                    value="female"
                                                    control={<Radio />}
                                                    label="Female"
                                                    sx={{ fontFamily: '"Segoe UI", sans-serif', fontSize: '15px', color: '#364252' }}
                                                />
                                            </RadioGroup>
                                        </FormControl>
                                    </Grid>
                                </Grid>
                            </AccordionDetails>
                        </Accordion> */}
                    </>
                </Grid>
            </Grid>
        </Box>
        <Grid size={{ md: 12, xs: 12 }}>
            <Box sx={{ borderBottom: '1px solid #ddd', width: '100%', marginTop: '10px', }}></Box>
        </Grid>
        <Box sx={{
            marginTop: '20px',
        }}>

            <Grid container spacing={2}>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Typography sx={{
                        fontFamily: 'Segoe UI',
                        fontSize: '20px',
                        fontWeight: 600,
                        textAlign: 'left',
                        color: '#1d1d1d',
                        marginBottom: '15px',
                    }}>
                        <img src={TravelImg} style={{ verticalAlign: '-webkit-baseline-middle', marginRight: '5px', marginBottom: '15px' }} />
                        Travel Tips & Policies</Typography>
                </Grid>
            </Grid>
            <Grid container spacing={2}>
                <Grid size={{ md: 12, xs: 12 }}>
                    <Accordion sx={{
                        borderRadius: "8px",
                        boxShadow: "none",
                        border: "1px solid #e5e5e5",
                        marginBottom: "15px",
                        "&::before": {
                            content: '""',
                            backgroundColor: "unset",
                            height: "unset",
                            position: "unset",
                        },
                    }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography
                                    sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#0e182b',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    Cancellation Policy
                                </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography>Cancellation Policy</Typography>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{
                        borderRadius: "8px",
                        boxShadow: "none",
                        border: "1px solid #e5e5e5",
                        marginBottom: "15px",
                        "&::before": {
                            content: '""',
                            backgroundColor: "unset",
                            height: "unset",
                            position: "unset",
                        },
                    }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography
                                    sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#0e182b',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    Luggage Guidelines
                                </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography>Luggage Guidelines</Typography>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{
                        borderRadius: "8px",
                        boxShadow: "none",
                        border: "1px solid #e5e5e5",
                        marginBottom: "15px",
                        "&::before": {
                            content: '""',
                            backgroundColor: "unset",
                            height: "unset",
                            position: "unset",
                        },
                    }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography
                                    sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#0e182b',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    Safety Measures
                                </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography>Safety Measures</Typography>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                    <Accordion sx={{
                        borderRadius: "8px",
                        boxShadow: "none",
                        border: "1px solid #e5e5e5",
                        marginBottom: "15px",
                        "&::before": {
                            content: '""',
                            backgroundColor: "unset",
                            height: "unset",
                            position: "unset",
                        },
                    }}>
                        <AccordionSummary
                            expandIcon={<ExpandMoreIcon />}
                            aria-controls="panel1-content"
                            id="panel1-header"
                        >
                            <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                                <Typography
                                    sx={{
                                        fontFamily: '"Segoe UI", sans-serif',
                                        fontSize: '15px',
                                        fontWeight: 600,
                                        color: '#0e182b',
                                        display: 'flex',
                                        alignItems: 'center',
                                    }}
                                >
                                    Amenity
                                </Typography>
                            </Box>
                        </AccordionSummary>
                        <AccordionDetails>
                            <Grid container spacing={2}>
                                <Grid size={{ md: 12, xs: 12 }}>
                                    <Typography>Amenity</Typography>
                                </Grid>
                            </Grid>
                        </AccordionDetails>
                    </Accordion>
                </Grid>
            </Grid>
        </Box>
    </>)
}


export default AddPassanger;